import styled from 'styled-components';
import { Divider, List, token } from '@bynder/design-system';

// Styles are absolute ass
// due to inability to style DS modal properly
// and lack of passed properties DS modal
export const StyledModalContainer = styled.div`
    & > div > div.react-responsive-modal-container {
        justify-content: start;
    }

    & > div > div.react-responsive-modal-container > div {
        height: 100%;
    }

    & > div > div.react-responsive-modal-container > div > :first-child {
        border-bottom: 1px solid ${token.gray100a};
    }
`;

export const StyledDivider = styled(Divider)`
    margin: 0 calc(${token.spacing6} * -1);
`;

export const ListItemContent = styled(List.Item)``;

export const ButtonWrapper = styled.div<{ $isVisible: boolean }>`
    /* Show when dropdown is opened */
    opacity: ${(props) => (props.$isVisible ? '1' : '0')};

    /* Show when parent component is hovered */
    ${ListItemContent}:hover & {
        opacity: 1;
    }
`;
